var exports = {
  "C": "boardSurface__yw-cmP",
};

module.exports = exports;
